module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sls"
  }, [_c('div', {
    staticClass: "sls-page-head"
  }, [_vm._m(0), _vm._v(" "), (!_vm.catalogEmpty) ? _c('div', {
    staticClass: "sls-head-actions"
  }, [_c('button', {
    staticClass: "sls-btn sls-btn-outline sls-btn-compact",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openExport
    }
  }, [_c('svg', {
    attrs: {
      "width": "14",
      "height": "14",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "aria-hidden": "true"
    }
  }, [_c('path', {
    attrs: {
      "d": "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"
    }
  }), _c('path', {
    attrs: {
      "d": "M7 10l5 5 5-5"
    }
  }), _c('path', {
    attrs: {
      "d": "M12 15V3"
    }
  })]), _vm._v("\n        Export\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "sls-status-line"
  }, [_vm._v("\n        Last updated "), _c('strong', [_vm._v(_vm._s(_vm.refreshedLabel))]), _vm._v(" · refreshes automatically every day\n        "), _c('button', {
    staticClass: "sls-refresh-btn",
    class: {
      'sls-refresh-spin': _vm.backfilling
    },
    attrs: {
      "type": "button",
      "title": "Re-scan your listings now",
      "aria-label": "Refresh now",
      "disabled": _vm.backfilling
    },
    on: {
      "click": _vm.backfill
    }
  }, [_c('svg', {
    attrs: {
      "width": "14",
      "height": "14",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "aria-hidden": "true"
    }
  }, [_c('path', {
    attrs: {
      "d": "M23 4v6h-6"
    }
  }), _c('path', {
    attrs: {
      "d": "M1 20v-6h6"
    }
  }), _c('path', {
    attrs: {
      "d": "M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"
    }
  })])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "sls-filter-bar"
  }, [_c('div', {
    staticClass: "sls-filters"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterSellerId),
      expression: "filterSellerId"
    }],
    staticClass: "sls-select sls-filter-select",
    attrs: {
      "aria-label": "Storefront"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterSellerId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("All storefronts")]), _vm._v(" "), _vm._l((_vm.storefrontOptions), function(acc) {
    return _c('option', {
      key: 'sf-' + acc.id,
      domProps: {
        "value": String(acc.id)
      }
    }, [_vm._v(_vm._s(acc.name))])
  })], 2), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterMarketplace),
      expression: "filterMarketplace"
    }],
    staticClass: "sls-select sls-filter-select",
    attrs: {
      "aria-label": "Marketplace"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterMarketplace = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("All marketplaces")]), _vm._v(" "), _vm._l((_vm.marketplaceOptions), function(code) {
    return _c('option', {
      key: 'mp-' + code,
      domProps: {
        "value": code
      }
    }, [_vm._v(_vm._s(code))])
  })], 2)])]), _vm._v(" "), (_vm.loading && !_vm.rows.length) ? _c('div', {
    staticClass: "sls-loading"
  }, [_c('div', {
    staticClass: "sls-spinner"
  })]) : _vm._e(), _vm._v(" "), (_vm.loadError && !_vm.rows.length && !_vm.loading) ? _c('div', {
    staticClass: "sls-error"
  }, [_c('p', {
    staticClass: "sls-error-title"
  }, [_vm._v("Could not load sellers")]), _vm._v(" "), _c('p', {
    staticClass: "sls-error-msg"
  }, [_vm._v(_vm._s(_vm.loadError))]), _vm._v(" "), _c('button', {
    staticClass: "sls-btn sls-btn-outline",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.fetchList
    }
  }, [_vm._v("Retry")])]) : _vm._e(), _vm._v(" "), (_vm.rows.length || (!_vm.loading && !_vm.loadError)) ? [(_vm.catalogEmpty) ? _c('div', {
    staticClass: "sls-empty"
  }, [_c('svg', {
    staticClass: "sls-empty-icon",
    attrs: {
      "width": "28",
      "height": "28",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.6",
      "aria-hidden": "true"
    }
  }, [_c('path', {
    attrs: {
      "d": "M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
    }
  }), _c('circle', {
    attrs: {
      "cx": "9",
      "cy": "7",
      "r": "4"
    }
  }), _c('path', {
    attrs: {
      "d": "M23 21v-2a4 4 0 0 0-3-3.87"
    }
  }), _c('path', {
    attrs: {
      "d": "M16 3.13a4 4 0 0 1 0 7.75"
    }
  })]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "sls-empty-title"
  }, [_vm._v("See who's competing for your Buy Box")]), _vm._v(" "), _c('p', {
    staticClass: "sls-empty-copy"
  }, [_vm._v("Backfilling scans your ASINs for every seller who currently has a competing offer on them. Name them once and every future alert uses their name instead of a random-looking ID.")]), _vm._v(" "), _c('button', {
    staticClass: "sls-btn sls-btn-primary",
    class: {
      'sls-btn-loading': _vm.backfilling
    },
    attrs: {
      "type": "button",
      "disabled": _vm.backfilling
    },
    on: {
      "click": _vm.backfill
    }
  }, [_vm._v(_vm._s(_vm.backfilling ? 'Scanning your listings…' : 'Backfill from your listings'))])])]) : [(_vm.totalItems) ? _c('div', {
    staticClass: "sls-progress"
  }, [_c('span', [_c('strong', [_vm._v(_vm._s(_vm.classifiedCount))]), _vm._v(" of " + _vm._s(_vm.totalItems) + " sellers classified")]), _vm._v(" "), _c('div', {
    staticClass: "sls-progress-bar",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('span', {
    style: ({
      width: _vm.classifiedPercent + '%'
    })
  })])]) : _vm._e(), _vm._v(" "), (_vm.selectedIds.length) ? _c('div', {
    staticClass: "sls-bulkbar"
  }, [_c('span', [_c('strong', [_vm._v(_vm._s(_vm.selectedIds.length))]), _vm._v(" selected")]), _vm._v(" "), _c('div', {
    staticClass: "sls-bulkbar-actions"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bulkRole),
      expression: "bulkRole"
    }],
    staticClass: "sls-select sls-bulk-select",
    attrs: {
      "aria-label": "Role for selected sellers"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.bulkRole = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.assignableRoles), function(opt) {
    return _c('option', {
      key: 'bulk-' + opt.value,
      domProps: {
        "value": opt.value
      }
    }, [_vm._v(_vm._s(opt.label))])
  }), 0), _vm._v(" "), _c('button', {
    staticClass: "sls-btn sls-btn-outline sls-btn-compact",
    class: {
      'sls-btn-loading': _vm.bulkSaving
    },
    attrs: {
      "type": "button",
      "disabled": _vm.bulkSaving
    },
    on: {
      "click": _vm.applyBulkRole
    }
  }, [_vm._v("Apply role")]), _vm._v(" "), _c('button', {
    staticClass: "sls-btn sls-btn-outline sls-btn-compact",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.exportSelected
    }
  }, [_vm._v("Export selected")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sls-table-wrap",
    class: {
      'sls-table-busy': _vm.loading,
      'sls-table-wrap--bulk': _vm.selectedIds.length
    }
  }, [_c('table', {
    staticClass: "sls-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "sls-th-check"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "aria-label": "Select all on this page",
      "disabled": !_vm.selectableRows.length
    },
    domProps: {
      "checked": _vm.allSelectableChecked
    },
    on: {
      "change": function($event) {
        return _vm.toggleSelectAll($event.target.checked)
      }
    }
  })]), _vm._v(" "), _c('th', [_vm._v("Marketplace")]), _vm._v(" "), _c('th', [_vm._v("Seller")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Role "), _c('span', {
    staticClass: "sls-info",
    attrs: {
      "tabindex": "0",
      "title": _vm.roleTooltip,
      "aria-label": _vm.roleTooltip
    }
  }, [_vm._v("ⓘ")])]), _vm._v(" "), _c('th', {
    staticClass: "sls-th-sorted",
    attrs: {
      "title": "Sorted by ASIN count, highest first"
    }
  }, [_vm._v("ASINs ▼")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('tbody', [(!_vm.rows.length && !_vm.loading) ? _c('tr', [_c('td', {
    staticClass: "sls-td-empty",
    attrs: {
      "colspan": "9"
    }
  }, [_vm._v("No competing offers for this storefront / marketplace.")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.rows), function(row) {
    return _c('tr', {
      key: row.id,
      class: {
        'sls-row-highlight': _vm.highlightId === row.id,
        'sls-row-suggested': _vm.hasSuggestion(row)
      },
      attrs: {
        "id": 'seller-row-' + row.id
      }
    }, [_c('td', {
      staticClass: "sls-td-check"
    }, [(!_vm.isSelf(row)) ? _c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": row.id,
        "checked": _vm.isSelected(row.id)
      },
      on: {
        "change": function($event) {
          return _vm.toggleSelected(row.id, $event.target.checked)
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "sls-mp-badge"
    }, [_vm._v(_vm._s(_vm.marketplaceCode(row)))])]), _vm._v(" "), _c('td', {
      staticClass: "sls-td-seller"
    }, [(_vm.profileUrl(row)) ? _c('a', {
      staticClass: "sls-seller-name",
      attrs: {
        "href": _vm.profileUrl(row),
        "target": "_blank",
        "rel": "noopener noreferrer"
      }
    }, [_vm._v(_vm._s(_vm.displayName(row)))]) : _c('span', {
      staticClass: "sls-seller-name"
    }, [_vm._v(_vm._s(_vm.displayName(row)))]), _vm._v(" "), _c('div', {
      staticClass: "sls-token"
    }, [_vm._v(_vm._s(_vm.merchantToken(row)))])]), _vm._v(" "), _c('td', [(_vm.isSelf(row)) ? _c('span', {
      staticClass: "sls-pill sls-pill-informational"
    }, [_vm._v("You")]) : (_vm.pillLabel(row)) ? _c('span', {
      staticClass: "sls-pill",
      class: 'sls-pill-' + _vm.pillTone(row)
    }, [_vm._v(_vm._s(_vm.pillLabel(row)))]) : _c('span', {
      staticClass: "sls-pill sls-pill-neutral"
    }, [_vm._v("New")])]), _vm._v(" "), _c('td', {
      staticClass: "sls-td-name"
    }, [_c('input', {
      staticClass: "sls-name-input",
      attrs: {
        "type": "text",
        "placeholder": _vm.namePlaceholder(row),
        "disabled": _vm.savingIds[row.id]
      },
      domProps: {
        "value": _vm.labelDraft(row)
      },
      on: {
        "input": function($event) {
          return _vm.onLabelInput(row, $event.target.value)
        },
        "keydown": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          $event.preventDefault();
          return _vm.saveLabel(row)
        },
        "blur": function($event) {
          return _vm.saveLabel(row)
        }
      }
    }), _vm._v(" "), (_vm.hasSuggestion(row)) ? _c('button', {
      staticClass: "sls-suggest",
      attrs: {
        "type": "button",
        "disabled": _vm.savingIds[row.id]
      },
      on: {
        "click": function($event) {
          return _vm.acceptSuggestion(row)
        }
      }
    }, [_vm._v("Use “" + _vm._s(row.suggested_label) + "”" + _vm._s(row.suggested_role ? ' as ' + _vm.roleLabel(row.suggested_role) : ''))]) : (_vm.showNameHint(row)) ? _c('p', {
      staticClass: "sls-field-hint"
    }, [_vm._v("Name this seller so the next alert uses it.")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "sls-td-role"
    }, [(_vm.isSelf(row)) ? [_c('span', {
      staticClass: "sls-you"
    }, [_vm._v("Your account")])] : [_c('select', {
      staticClass: "sls-select",
      attrs: {
        "title": _vm.roleHelper(row),
        "disabled": !!_vm.savingIds[row.id]
      },
      domProps: {
        "value": _vm.roleValue(row)
      },
      on: {
        "change": function($event) {
          return _vm.saveRole(row, $event.target.value)
        }
      }
    }, _vm._l((_vm.assignableRoles), function(opt) {
      return _c('option', {
        key: opt.value,
        domProps: {
          "value": opt.value
        }
      }, [_vm._v(_vm._s(opt.label))])
    }), 0), _vm._v(" "), (_vm.showDigestNote(row)) ? _c('p', {
      staticClass: "sls-field-hint"
    }, [_vm._v("Instant Buy Box emails until Offer activity digest is on.")]) : _vm._e()]], 2), _vm._v(" "), _c('td', {
      staticClass: "sls-td-asins"
    }, [_vm._v(_vm._s(_vm.asinCount(row)))]), _vm._v(" "), _c('td', {
      staticClass: "sls-td-seen"
    }, [_vm._v(_vm._s(_vm.formatDay(row.first_seen)))]), _vm._v(" "), _c('td', {
      staticClass: "sls-td-seen"
    }, [_vm._v(_vm._s(_vm.formatDay(row.last_seen)))])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "sls-pagination"
  }, [_c('span', {
    staticClass: "sls-page-label"
  }, [_vm._v(_vm._s(_vm.pageLabel))]), _vm._v(" "), _c('div', {
    staticClass: "sls-page-controls"
  }, [_c('button', {
    staticClass: "sls-page-btn",
    attrs: {
      "type": "button",
      "disabled": _vm.page <= 1 || _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.goToPage(1)
      }
    }
  }, [_vm._v("«")]), _vm._v(" "), _c('button', {
    staticClass: "sls-page-btn",
    attrs: {
      "type": "button",
      "disabled": _vm.page <= 1 || _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.goToPage(_vm.page - 1)
      }
    }
  }, [_vm._v("‹")]), _vm._v(" "), _c('span', {
    staticClass: "sls-page-num"
  }, [_vm._v(_vm._s(_vm.page) + " / " + _vm._s(_vm.totalPages))]), _vm._v(" "), _c('button', {
    staticClass: "sls-page-btn",
    attrs: {
      "type": "button",
      "disabled": _vm.page >= _vm.totalPages || _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.goToPage(_vm.page + 1)
      }
    }
  }, [_vm._v("›")]), _vm._v(" "), _c('button', {
    staticClass: "sls-page-btn",
    attrs: {
      "type": "button",
      "disabled": _vm.page >= _vm.totalPages || _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.goToPage(_vm.totalPages)
      }
    }
  }, [_vm._v("»")])])])]] : _vm._e(), _vm._v(" "), (_vm.exportOpen) ? _c('div', {
    staticClass: "sls-modal-backdrop",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.exportOpen = false
      }
    }
  }, [_c('div', {
    staticClass: "sls-modal",
    attrs: {
      "role": "dialog",
      "aria-modal": "true",
      "aria-labelledby": "sls-export-title"
    }
  }, [_c('h3', {
    staticClass: "sls-modal-title",
    attrs: {
      "id": "sls-export-title"
    }
  }, [_vm._v("Export sellers")]), _vm._v(" "), _c('p', {
    staticClass: "sls-modal-hint"
  }, [_vm._v("Only sellers with offer activity inside this window are included. Storefront and marketplace filters apply.")]), _vm._v(" "), _c('div', {
    staticClass: "sls-modal-dates"
  }, [_c('label', [_vm._v("From"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exportFrom),
      expression: "exportFrom"
    }],
    attrs: {
      "type": "date",
      "max": _vm.exportTo
    },
    domProps: {
      "value": (_vm.exportFrom)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.exportFrom = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', [_vm._v("To"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exportTo),
      expression: "exportTo"
    }],
    attrs: {
      "type": "date",
      "min": _vm.exportFrom
    },
    domProps: {
      "value": (_vm.exportTo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.exportTo = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sls-modal-formats"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exportFormat),
      expression: "exportFormat"
    }],
    attrs: {
      "type": "radio",
      "value": "csv"
    },
    domProps: {
      "checked": _vm._q(_vm.exportFormat, "csv")
    },
    on: {
      "change": function($event) {
        _vm.exportFormat = "csv"
      }
    }
  }), _vm._v(" CSV")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exportFormat),
      expression: "exportFormat"
    }],
    attrs: {
      "type": "radio",
      "value": "xlsx"
    },
    domProps: {
      "checked": _vm._q(_vm.exportFormat, "xlsx")
    },
    on: {
      "change": function($event) {
        _vm.exportFormat = "xlsx"
      }
    }
  }), _vm._v(" XLSX")])]), _vm._v(" "), (_vm.exportRangeError) ? _c('p', {
    staticClass: "sls-modal-error"
  }, [_vm._v(_vm._s(_vm.exportRangeError))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sls-modal-actions"
  }, [_c('button', {
    staticClass: "sls-btn sls-btn-outline sls-btn-compact",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.exportOpen = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "sls-btn sls-btn-primary sls-btn-compact",
    class: {
      'sls-btn-loading': _vm.exporting
    },
    attrs: {
      "type": "button",
      "disabled": _vm.exporting || !!_vm.exportRangeError
    },
    on: {
      "click": _vm.exportReport
    }
  }, [_vm._v(_vm._s(_vm.exporting ? 'Exporting…' : 'Export'))])])])]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "sls-slide-up"
    }
  }, [(_vm.successMsg) ? _c('div', {
    staticClass: "sls-toast sls-toast-ok"
  }, [_vm._v(_vm._s(_vm.successMsg))]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "sls-slide-up"
    }
  }, [(_vm.errorMsg) ? _c('div', {
    staticClass: "sls-toast sls-toast-err"
  }, [_vm._v(_vm._s(_vm.errorMsg))]) : _vm._e()])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sls-page-head-text"
  }, [_c('h1', {
    staticClass: "sls-title"
  }, [_vm._v("Hijacker")]), _vm._v(" "), _c('p', {
    staticClass: "sls-subtitle"
  }, [_vm._v("Name competitors and choose how SentryKit treats them on each marketplace.")]), _vm._v(" "), _c('p', {
    staticClass: "sls-page-note"
  }, [_vm._v("Storefront and marketplace change which sellers you see below. A seller's name and role are saved per marketplace and apply across all your storefronts.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_vm._v("First seen "), _c('span', {
    staticClass: "sls-info",
    attrs: {
      "tabindex": "0",
      "title": "When SentryKit first saw this seller's current offer on one of your ASINs."
    }
  }, [_vm._v("ⓘ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_vm._v("Last seen on Buy Box "), _c('span', {
    staticClass: "sls-info",
    attrs: {
      "tabindex": "0",
      "title": "The most recent time this seller's offer on one of your ASINs changed or was confirmed."
    }
  }, [_vm._v("ⓘ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ce22300c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/SellersSettings.vue
// module id = 811
// module chunks = 2